
import React, { useState, useEffect } from 'react'
import { Button, Dialog, Grid, Icon, Typography, FormHelperText } from '@material-ui/core'
import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import RichTextEditor from 'react-rte';
import DialogLoader from '../../../components/Loader/DialogLoader';

import { InputBaseField, TextareaField } from '../../../components/InputField/InputField';
import { Label, DraggableComponent } from '../../../components/UiElements/UiElements'
import { PostDataAPI } from '../../../Services/APIService';
import { withSnackbar } from "../../../components/Message/Alert";
import useStyles from "./styles";

function AddNewBlog({ dialogOpenClose, handleClose, postType, handleSuccessClose, data, ...props }) {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    //const [state, setState] = useState({});
    const [editorValue, setEditorValue] = useState(RichTextEditor.createValueFromString("", 'html'));
    const [state, setState] = useState({
        galleryBase64: [],
        galleryVideos: [],
    });

    const regex = /(<([^>]+)>)/ig;
    const regexSpaces = /((&nbsp;))*/gmi;

    const [errorMessages, setErrorMessages] = useState({});

    const { showMessage } = props;

    const [videoPath, setVideoPath] = useState(null);

    // Sync state when data changes (edit case)
    useEffect(() => {
        if (data && data.postId > 0) {
            const updated = {
                ...data,
                publishedDate: data.publishedDate ? data.publishedDate.split("T")[0] : ""
            };

            if (data.videoPath !== null) {
                setVideoPath(data.videoPath)
            }


            LoadGallery(data.postId, updated);
            if (data.content) {
                const newValue = RichTextEditor.createValueFromString(data.content, 'html');
                setEditorValue(newValue);
            }
        } else {
            setState({ ...data, type: postType });
            setEditorValue(RichTextEditor.createValueFromString("", 'html'));
        }
    }, [data, postType]);

    const handleEditorChange = (val) => {
        setEditorValue(val);
        if (!isEditorEmpty(val)) {
            setErrorMessages(prev => ({ ...prev, errorContent: false }));
        }
    };

    function isEditorEmpty(_editorValue) {
        let editorDetail = _editorValue.toString('html').replace(regex, '');
        return (
            editorDetail.trim() === "" ||
            editorDetail === "<p><br></p>" ||
            !!editorDetail.replace(regex, "") === "" ||
            !!editorDetail.replace(regexSpaces, '') === "" ||
            editorDetail === "<p></p>"
        );
    }

    const handleChange = e => {
        const { name, value } = e.target;
        setState(prev => ({ ...prev, [name]: value }));
    };

    const handleChangeFile = (event) => {
        const input = event.target;
        const { name, files } = input;

        if (!files || files.length === 0) return;

        const file = files[0];

        // ✅ validation by field
        if (
            (name === "thumbnailBase64" || name === "bannerBase64") &&
            !file.type.startsWith("image/")
        ) {
            showMessage("Error", "Only image files are allowed.", "error", 3000);
            input.value = "";
            return;
        }

        if (name === "videoBase64" && file.type !== "video/mp4") {
            showMessage("Error", "Only MP4 video is allowed.", "error", 3000);
            input.value = "";
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            setState(prev => ({
                ...prev,
                [name]: reader.result
            }));
        };

        reader.readAsDataURL(file);
    };

    const handleVideoUpload = (event) => {
        const files = Array.from(event.target.files);
        if (!files.length) return;

        const videos = [];

        files.forEach((file) => {
            if (file.type === "video/mp4") {
                videos.push(file);
            } else {
                showMessage("Error", "File " + file.name + " is not an MP4 video. Please upload only MP4 files.", "error", 3000);
            }
        });

        if (videos.length > 0) {
            setState(prev => ({
                ...prev,
                galleryVideos: [...(prev.galleryVideos || []), ...videos],
            }));
        }
    };


    const handleGalleryFiles = (event) => {
        const files = Array.from(event.target.files);
        if (!files.length) return;

        const images = [];
        const videos = [];

        files.forEach((file) => {
            if (file.type.startsWith("image")) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    images.push(reader.result);
                    if (images.length === files.filter(f => f.type.startsWith("image")).length) {
                        setState(prev => ({
                            ...prev,
                            galleryBase64: [...(prev.galleryBase64 || []), ...images],
                        }));
                    }
                };
                reader.readAsDataURL(file);
            }

            if (file.type.startsWith("video")) {
                videos.push(file);
            }
        });

        if (videos.length > 0) {
            setState(prev => ({
                ...prev,
                galleryVideos: [...(prev.galleryVideos || []), ...videos],
            }));
        }
    };

    const Validate = (errorList) => {
        if (!state.title) {
            setErrorMessages(prev => ({ ...prev, errorTitle: true }));
            errorList.push(true);
        }
        // Thumbnail check (Base64 OR Path)
        if (!(state.thumbnailBase64 || state.thumbnailPath)) {
            setErrorMessages(prev => ({ ...prev, errorThumbnailBase64: true }));
            errorList.push(true);
        } else {
            setErrorMessages(prev => ({ ...prev, errorThumbnailBase64: false }));
        }

        // Banner check (Base64 OR Path)
        if (!(state.bannerBase64 || state.bannerPath)) {
            setErrorMessages(prev => ({ ...prev, errorBannerBase64: true }));
            errorList.push(true);
        } else {
            setErrorMessages(prev => ({ ...prev, errorBannerBase64: false }));
        }
        if (isEditorEmpty(editorValue)) {
            setErrorMessages(prev => ({ ...prev, errorContent: true }));
            errorList.push(true);
        }
    };
    const addBlog = () => {
        let errorList = [];
        Validate(errorList);
        if (errorList.length < 1) {
            setIsLoading(true);
            const payload = { ...state, content: editorValue.toString('html') };
            let method = "fdnpost/addPost";
            if (data.postId > 0) {
                method = "fdnpost/updatePost";
            }
            PostDataAPI(method, payload, true).then((result) => {
                setIsLoading(false);
                if (result.success) {
                    uploadVideos(data.postId > 0 ? data.postId : result.data.postId);
                    handleSuccessClose('Your article has been published');
                    showMessage("Success", "Your article has been published", "success", 3000);
                }
            });
        }
    };
    const uploadVideos = (postId) => {
        debugger
        if (!state.galleryVideos || !state.galleryVideos.length) return;

        const formData = new FormData();
        state.galleryVideos.forEach(v => formData.append("videos", v));
        formData.append("postId", postId);


        PostDataAPI("fdnpost/uploadPostVideos", formData, true, "formData").then((result) => {
            setIsLoading(false)
            if (!result.success && result.message) {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        })
    };
    const LoadGallery = (postId, data) => {
        var params = {
            postId: postId
        }
        setIsLoading(true);
        PostDataAPI("fdnpost/getPostGalleryByPostId", params, true).then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                data.galleryPaths = result.data
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
            setState(data);
        });
    };
    const closeModal = () => {
        setState({});
        setEditorValue(RichTextEditor.createValueFromString('', 'html'));
        setTimeout(() => {
            handleClose();
        }, 100);
    };
    const handleRemoveImage = (index) => {
        setState((prev) => ({
            ...prev,
            galleryPaths: prev.galleryPaths.filter((_, i) => i !== index),
        }));
    };

    const handleRemoveBase64Image = (index) => {
        setState((prev) => ({
            ...prev,
            galleryBase64: prev.galleryBase64.filter((_, i) => i !== index),
        }));
    };
    const handleRemoveVideo = (index) => {
        setState((prev) => {
            URL.revokeObjectURL(prev.galleryVideos[index]);
            return {
                ...prev,
                galleryVideos: prev.galleryVideos.filter((_, i) => i !== index),
            };
        });
    };

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            PaperComponent={DraggableComponent}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            maxWidth="lg"
            {...props}
        >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>
                            {data.postId > 0 ? 'Update' : 'Add'} {postType === 'News' ? "News" : "Blog"}
                        </Typography>
                        <Icon className={classes.closeIcon} onClick={closeModal} color="primary">
                            <CloseIcon />
                        </Icon>
                    </div>
                    {isLoading && <DialogLoader />}
                    <Scrollbars autoHeight autoHeightMax={570}>
                        <div className={classes.content}>

                            {/* Title */}
                            <Grid container>
                                <Label size={12} title="Title" mandatory />
                                <Grid item xs={12}>
                                    <InputBaseField
                                        id="title"
                                        name="title"
                                        type="text"
                                        value={state.title || ""}
                                        onChange={handleChange}
                                        placeholder='Title'
                                    />
                                    {errorMessages.errorTitle && !state.title && (
                                        <FormHelperText style={{ color: "red" }}>Please enter Title</FormHelperText>
                                    )}
                                </Grid>
                            </Grid>

                            {/* Content */}
                            <Grid container>
                                <Label size={12} title="Content" mandatory />
                                <Grid item xs={12}>
                                    <RichTextEditor
                                        value={editorValue}
                                        onChange={handleEditorChange}
                                        className={classes.content}
                                        placeholder="Enter Content"
                                    />
                                    {errorMessages.errorContent && (
                                        <FormHelperText style={{ color: "red" }}>Please enter content</FormHelperText>
                                    )}
                                </Grid>
                            </Grid>

                            {/* Short Description */}
                            <Grid container>
                                <Label size={12} title="Short Description" />
                                <Grid item xs={12}>
                                    <TextareaField
                                        name="shortDescription"
                                        value={state.shortDescription || ""}
                                        onChange={handleChange}
                                        placeholder="Short Description"
                                        rows={3}
                                    />
                                </Grid>
                            </Grid>

                            {/* Published Date */}
                            <Grid container spacing={4}>
                                <Grid item sm={6}>
                                    <Label title="Article Video" size={12} />
                                    <Grid item xs={12}>
                                        <InputBaseField
                                            id="galleryBase64"
                                            name="galleryBase64"
                                            type="file"
                                            multiple
                                            accept={"video/*"}
                                            onChange={handleVideoUpload}
                                        />

                                    </Grid>
                                </Grid>
                                <Grid item sm={6}>
                                    <Label title="Published Date" size={12} />
                                    <Grid item xs={12}>
                                        <InputBaseField
                                            id="publishedDate"
                                            name="publishedDate"
                                            type="date"
                                            value={state.publishedDate || ""}
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={4}>
                                <Grid item sm={12}>
                                    {state.galleryVideos && state.galleryVideos.length > 0 ?
                                        (
                                            <div style={{ marginTop: 10, display: "flex", flexWrap: "wrap" }}>
                                                {state.galleryVideos.map((video, idx) => (
                                                    <div
                                                        key={`video-${idx}`}
                                                        style={{ position: "relative", width: 200, height: 120, marginRight: 20 }}
                                                    >
                                                        <span
                                                            onClick={() => handleRemoveVideo(idx)}
                                                            style={{
                                                                position: "absolute",
                                                                top: 5,
                                                                right: 5,
                                                                background: "rgba(0,0,0,0.6)",
                                                                color: "#fff",
                                                                borderRadius: "50%",
                                                                width: 22,
                                                                height: 22,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                cursor: "pointer",
                                                                zIndex: 1,
                                                            }}
                                                        >
                                                            X
                                                        </span>

                                                        <video
                                                            src={URL.createObjectURL(video)}
                                                            controls
                                                            style={{ width: "100%", height: "100%", borderRadius: 5 }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        ) :
                                        videoPath !== null ?

                                            <video width={300} controls style={{ borderRadius: 5 }}>
                                                <source src={'/' + videoPath} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>: ''
                                    }
                                </Grid>
                            </Grid>
                            {/* Thumbnail & Banner */}
                            <Grid container spacing={4}>
                                {/* Thumbnail */}
                                <Grid item sm={6}>
                                    <Label size={12} title="Thumbnail" mandatory />
                                    <InputBaseField
                                        id="thumbnailBase64"
                                        name="thumbnailBase64"
                                        type="file"
                                        onChange={handleChangeFile}
                                    />
                                    {(state?.thumbnailBase64 || state?.thumbnailPath) && (
                                        <div style={{ marginTop: 10 }}>
                                            <img
                                                src={state?.thumbnailBase64 || `/assets/images/resources/${state.thumbnailPath}`}
                                                alt="Thumbnail Preview"
                                                style={{ width: 200, height: 120, objectFit: "cover", borderRadius: 4 }}
                                            />
                                        </div>
                                    )}
                                    {errorMessages.errorThumbnailBase64 && !state.thumbnailBase64 && (
                                        <FormHelperText style={{ color: "red" }}>Please add thumbnail</FormHelperText>
                                    )}
                                </Grid>

                                {/* Banner */}
                                <Grid item sm={6}>
                                    <Label size={12} title="Feature Image" mandatory />
                                    <InputBaseField
                                        id="bannerBase64"
                                        name="bannerBase64"
                                        type="file"
                                        onChange={handleChangeFile}
                                    />
                                    {(state.bannerBase64 || state.bannerPath) && (
                                        <div style={{ marginTop: 10 }}>
                                            <img
                                                src={state?.bannerBase64 || `/assets/images/resources/${state?.bannerPath}`}
                                                alt="Banner Preview"
                                                style={{ width: 200, height: 120, objectFit: "cover", borderRadius: 4 }}
                                            />
                                        </div>
                                    )}
                                    {errorMessages.errorBannerBase64 && !state?.bannerBase64 && (
                                        <FormHelperText style={{ color: "red" }}>Please add feature image</FormHelperText>
                                    )}
                                </Grid>

                            </Grid>

                            {/* Gallery */}
                            <Grid container>
                                <Label size={12} title="Gallery Images" />
                                <InputBaseField
                                    id="galleryBase64"
                                    name="galleryBase64"
                                    type="file"
                                    multiple
                                    accept="image/*,video/*"
                                    onChange={handleGalleryFiles}
                                />

                                {/* Show base64 uploaded images */}
                                {state.galleryBase64 && state.galleryBase64.length > 0 && (
                                    <div style={{ marginTop: 10, display: "flex", flexWrap: "wrap" }}>
                                        {state.galleryBase64.map((img, idx) => (
                                            <div
                                                key={`base64-${idx}`}
                                                style={{
                                                    position: "relative",
                                                    width: 200,
                                                    height: 120,
                                                    marginRight: 20,
                                                    marginBottom: 10,
                                                }}
                                            >
                                                {/* Cross icon */}
                                                <span
                                                    onClick={() => handleRemoveBase64Image(idx)}
                                                    style={{
                                                        position: "absolute",
                                                        top: 5,
                                                        right: 5,
                                                        background: "rgba(0,0,0,0.6)",
                                                        color: "#fff",
                                                        borderRadius: "50%",
                                                        width: 22,
                                                        height: 22,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        cursor: "pointer",
                                                        fontSize: 14,
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    X
                                                </span>

                                                <img
                                                    src={img}
                                                    alt={`gallery-${idx}`}
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        borderRadius: 5,
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                )}



                                {/* Show already saved gallery paths from backend */}
                                {state.galleryPaths && state.galleryPaths.length > 0 && (
                                    <div style={{ marginTop: 10, display: "flex", flexWrap: "wrap" }}>
                                        {state.galleryPaths.map((item, idx) => (
                                            <div
                                                key={`path-${idx}`}
                                                style={{
                                                    position: "relative",
                                                    width: 200,
                                                    height: 120,
                                                    marginRight: 20,
                                                    marginBottom: 10,
                                                }}
                                            >
                                                {/* Cross icon */}
                                                <span
                                                    onClick={() => handleRemoveImage(idx)}
                                                    style={{
                                                        position: "absolute",
                                                        top: 5,
                                                        right: 5,
                                                        background: "rgba(0,0,0,0.6)",
                                                        color: "#fff",
                                                        borderRadius: "50%",
                                                        width: 22,
                                                        height: 22,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        cursor: "pointer",
                                                        fontSize: 14,
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    X
                                                </span>

                                                <img
                                                    src={`/news/${item.imagePath}`}
                                                    alt={`gallery-${idx}`}
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        borderRadius: 5,
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                )}

                            </Grid>


                        </div>
                    </Scrollbars>
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} onClick={closeModal}>Close</Button>
                            <Button className={classes.changeBtn} onClick={addBlog}>
                                {data.postId > 0 ? 'Update' : 'Add'} {postType === 'News' ? "News" : "Blog"}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}

export default withSnackbar(AddNewBlog);
